import { FormGroup } from '@angular/forms';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { isEqual } from 'lodash-es';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { toNum } from '@shared/helpers/math.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { MyAllElemCollegioSindacaleEntity } from '../../../../models/interfaces/revisione.interface';
import {
    getNormeSrlControl,
    getAmmControlloControl,
    normeSrlCkHelper,
    normeSrlRequiredHelper,
    checkCkNormeValue,
} from './helpers/norme-srl-form-validators.helper';

export const normeSrlAssembleaRules: FormGroupRules = {
    my_CkSrlMaggAmminSoci: (form: FormGroup) => {
        normeSrlCkHelper(form, 'my_NormeSrl.my_CkSrlMaggAmminSoci', 'my_NormeSrl.my_CkSrlTipoAmministrazione', 1);
    },

    my_CkSrlStatutoFormeAmmin: (form: FormGroup) => {
        normeSrlCkHelper(form, 'my_NormeSrl.my_CkSrlStatutoFormeAmmin', 'my_NormeSrl.my_CkSrlTipoAmministrazione', 1);
    },

    my_CkSrlAmminCarattMutual: (form: FormGroup) => {
        normeSrlCkHelper(form, 'my_NormeSrl.my_CkSrlAmminCarattMutual', 'my_NormeSrl.my_CkSrlTipoAmministrazione', 1);
    },

    my_CkSrlSindaciConsAmmin: (form: FormGroup) => {
        const my_CkSrlAssembNominSind: string = getNormeSrlControl(form, 'my_CkSrlAssembNominSind').value;
        normeSrlCkHelper(
            form,
            'my_NormeSrl.my_CkSrlSindaciConsAmmin',
            'my_NormeSrl.my_CkSrlTipoAmministrazione',
            1,
            formPaths.ammControllo,
            my_CkSrlAssembNominSind === '1'
        );
    },

    my_CkSrlCompStatoInConsAmmin: (form: FormGroup) => {
        normeSrlCkHelper(form, 'my_NormeSrl.my_CkSrlCompStatoInConsAmmin', 'my_NormeSrl.my_CkSrlTipoAmministrazione', 1);
    },

    my_CkSrlRegistroDelib: (form: FormGroup) => {
        normeSrlCkHelper(form, 'my_NormeSrl.my_CkSrlRegistroDelib', 'my_NormeSrl.my_CkSrlTipoAmministrazione', 2);
    },

    my_CkSrlCompElettiStrFinan: (form: FormGroup) => {
        normeSrlCkHelper(form, 'my_NormeSrl.my_CkSrlCompElettiStrFinan', 'my_NormeSrl.my_CkSrlTipoAmministrazione', 1);
    },

    my_CkSrlCompElettiLimite: (form: FormGroup) => {
        const my_CkSrlCompElettiStrFinan: string = getNormeSrlControl(form, 'my_CkSrlCompElettiStrFinan').value;
        normeSrlCkHelper(
            form,
            'my_NormeSrl.my_CkSrlCompElettiLimite',
            'my_NormeSrl.my_CkSrlTipoAmministrazione',
            1,
            formPaths.ammControllo,
            my_CkSrlCompElettiStrFinan === '1'
        );
    },

    my_CkSrlStatutoFormeAmminDisg: (form: FormGroup) => {
        normeSrlCkHelper(form, 'my_NormeSrl.my_CkSrlStatutoFormeAmminDisg', 'my_NormeSrl.my_CkSrlTipoAmministrazione', 1);
    },

    my_CKSRLAmmUniRelCarMutua: (form: FormGroup) => {
        normeSrlCkHelper(form, 'my_NormeSrl.my_gruppo1.my_CKSRLAmmUniRelCarMutua', 'my_NormeSrl.my_CkSrlTipoAmministrazione', 2);
    },

    my_CkSrlCoop9soci: (form: FormGroup) => {
        normeSrlRequiredHelper(form, 'my_NormeSrl.my_CkSrlCoop9soci');
    },

    my_CkSrlCoop20soci: (form: FormGroup) => {
        normeSrlRequiredHelper(form, 'my_NormeSrl.my_CkSrlCoop20soci');
    },

    my_CkSrlAssembAppBil: (form: FormGroup) => {
        normeSrlRequiredHelper(form, 'my_NormeSrl.my_CkSrlAssembAppBil');
    },

    my_CkSrlAssembNominAmmin: (form: FormGroup) => {
        normeSrlRequiredHelper(form, 'my_NormeSrl.my_CkSrlAssembNominAmmin');
    },

    my_CkSrlCoopTenutaNominaCollSind: (form: FormGroup) => {
        normeSrlRequiredHelper(form, 'my_NormeSrl.my_CkSrlCoopTenutaNominaCollSind');
    },

    my_CkSrlAssembNominSind: (form: FormGroup) => {
        const my_CkSrlAssembNominSindControl = getNormeSrlControl(form, 'my_CkSrlAssembNominSind');
        const my_CkSrlAssembNominSind = toNum(my_CkSrlAssembNominSindControl.value);
        const my_AllElemCollegioSindacale: MyAllElemCollegioSindacaleEntity[] = getAmmControlloControl(
            form,
            'my_AllCollegioSindacale.my_AllElemCollegioSindacale'
        ).value;
        const errors = my_CkSrlAssembNominSindControl.errors ? my_CkSrlAssembNominSindControl.errors : {};

        addRemoveError(my_CkSrlAssembNominSind === 1 && checkCkNormeValue(form) && isNilOrEmpty(my_AllElemCollegioSindacale), errors, 'my_CkSrlAssembNominSind', {
            status: "Inserire l'organo di controllo",
        });

        addRemoveError(my_CkSrlAssembNominSind === 0 && checkCkNormeValue(form) && !isNilOrEmpty(my_AllElemCollegioSindacale), errors, 'my_CkSrlAssembNominSind', {
            status: "Eliminare l'organo di controllo",
            message: "In caso di risposta negativa occorre eliminare tutti i membri dell'organo di controllo",
        });

        addRemoveError(isNilOrEmpty(my_CkSrlAssembNominSind) && checkCkNormeValue(form), errors, 'my_CkSrlAssembNominSind', {
            status: REQUIRED_STATUS,
        });

        my_CkSrlAssembNominSindControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSrlAssembNominOrgano: (form: FormGroup) => {
        normeSrlRequiredHelper(form, 'my_NormeSrl.my_CkSrlAssembNominOrgano');
    },

    my_CkSrlGratuitaCariche: (form: FormGroup) => {
        normeSrlRequiredHelper(form, 'my_NormeSrl.my_CkSrlGratuitaCariche');
    },

    my_SrlNoteFunzAssemb: (form: FormGroup) => {
        normeSrlRequiredHelper(form, 'my_NormeSrl.my_SrlNoteFunzAssemb');
    },

    my_CkSrlAssembDetCompAmmin: (form: FormGroup) => {
        const my_CkSrlAssembDetCompAmminControl = getNormeSrlControl(form, 'my_CkSrlAssembDetCompAmmin');
        const my_CkSrlGratuitaCariche: string = getNormeSrlControl(form, 'my_CkSrlGratuitaCariche').value;
        const errors = my_CkSrlAssembDetCompAmminControl.errors ? my_CkSrlAssembDetCompAmminControl.errors : {};

        addRemoveError(isNilOrEmpty(my_CkSrlAssembDetCompAmminControl?.value) && my_CkSrlGratuitaCariche === '0' && checkCkNormeValue(form), errors, 'my_CkSrlAssembDetCompAmmin', {
            status: REQUIRED_STATUS,
        });

        my_CkSrlAssembDetCompAmminControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSrlAssembDetCompSindaci: (form: FormGroup) => {
        const my_CkSrlAssembDetCompSindaciControl = getNormeSrlControl(form, 'my_CkSrlAssembDetCompSindaci');
        const my_CkSrlGratuitaCariche: string = getNormeSrlControl(form, 'my_CkSrlGratuitaCariche').value;
        const my_CkSrlAssembNominSind: string = getNormeSrlControl(form, 'my_CkSrlAssembNominSind').value;
        const showError = isNilOrEmpty(my_CkSrlAssembDetCompSindaciControl?.value) && my_CkSrlGratuitaCariche === '0' && my_CkSrlAssembNominSind === '1' && checkCkNormeValue(form);
        const errors = my_CkSrlAssembDetCompSindaciControl.errors ? my_CkSrlAssembDetCompSindaciControl.errors : {};

        addRemoveError(showError, errors, 'my_CkSrlAssembDetCompSindaci', {
            status: REQUIRED_STATUS,
        });

        my_CkSrlAssembDetCompSindaciControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkSindaciRiunioniLiquidatori: (form: FormGroup) => {
        const my_CkSindaciRiunioniLiquidatoriControl = getAmmControlloControl(form, 'my_CkSindaciRiunioniLiquidatori');
        const my_AllElemLiquidatori: string = getAmmControlloControl(form, 'my_AllLiquidatori.my_AllElemLiquidatori').value;
        const my_CkSrlAssembNominSind: string = getNormeSrlControl(form, 'my_CkSrlAssembNominSind').value;
        const errors = my_CkSindaciRiunioniLiquidatoriControl.errors ? my_CkSindaciRiunioniLiquidatoriControl.errors : {};

        addRemoveError(
            isNilOrEmpty(my_CkSindaciRiunioniLiquidatoriControl?.value) && !isNilOrEmpty(my_AllElemLiquidatori) && my_CkSrlAssembNominSind === '1',
            errors,
            'my_CkSindaciRiunioniLiquidatori',
            { status: REQUIRED_STATUS }
        );

        my_CkSindaciRiunioniLiquidatoriControl.setErrors(isEqual(errors, {}) ? null : errors);
    },
};
